import Header from "./components/header/Header";
import Info from "./components/body/Info";
import "./App.css";

function App() {
  return (
    <div className="application_wrapper">
      <Header />
      <Info />
    </div>
  );
}

export default App;
